"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUndefinedProps = void 0;
const deleteUndefinedProps = (obj) => {
    Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);
    return obj;
};
exports.deleteUndefinedProps = deleteUndefinedProps;
//# sourceMappingURL=deleteUndefinedProps.js.map